
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/stations-ouvertes",
      function () {
        return require("private-next-pages/[region]/stations-ouvertes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/stations-ouvertes"])
      });
    }
  